module.exports = __webpack_public_path__ + "img/microplastics-3.0eb6ab8d.png";